import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import { QueryType } from '../../../../../utils/apollo/graphqlSchema';
import { setTriggerSubjectAction } from '../../../../../redux/slices/oldBuilder';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';

const TriggerSubject = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(
    defaultOptions?.type === QueryType.Expression &&
      selectedOptions?.type === QueryType.Expression,
  );

  const { impactModeConfig } = defaultOptions;

  const selectedTriggerSubject = selectedOptions.triggerSubject;

  const handleChange = useCallback(
    (triggerSubjectKey: string) => {
      dispatch(
        setTriggerSubjectAction({
          triggerSubjectKey,
        }),
      );
    },
    [dispatch],
  );

  return (
    <BuilderEnumSelect
      label={'Subject'}
      enumOptions={impactModeConfig.subjects}
      selectedOption={selectedTriggerSubject}
      onChange={handleChange}
    />
  );
};

export default TriggerSubject;
